import type { ApiInspectReport } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type InspectReportUpdatedEvent = AvvirEvent<typeof INSPECT_REPORT_UPDATED, { inspectReport: ApiInspectReport }>

const inspectReportUpdated = (inspectReport: ApiInspectReport): InspectReportUpdatedEvent =>({
  type: INSPECT_REPORT_UPDATED,
  payload: {
    inspectReport
  }
})

export const INSPECT_REPORT_UPDATED = "inspect_report_updated";

export default inspectReportUpdated;
